<template>
    <Page class="overview">
        <div class="header">
            Simplify Kubernetes Observability with Coroot
        </div>

        <div class="subheader">
            If you’re looking for Observability capable of providing simple actionable insights for your application deployed on Kubernetes,
            Coroot can be a great fit.
        </div>

        <v-row class="features">
            <v-col cols="12" lg="6" order="2" order-lg="1">
                <div class="feature">
                    Coroot is a Kubernetes Native Observability solution designed with deep understanding of Kubernetes concepts
                    and leveraging full built-in observability capabilities, using eBPF for zero-code instrumentation and automatic logs discovery.
                </div>
                <div class="feature">
                    Application Centric Observability allows you to focus on the application and, clearly see its upstreams and downstreams,
                    without the need to manually track nodes used by this application.
                </div>
                <div class="feature">
                    Kubernetes <router-link to="/docs/coroot-community-edition/inspections/deployment-tracking">Deployment Tracking</router-link>
                    allows to clearly see how the deployment of new code impacts applications performance, resource consumption, and costs.
                </div>
                <div class="feature">
                    Simple, <router-link to="/docs/coroot-community-edition/getting-started/installation">all-in-one installation with Helm</router-link>
                    allows you to deploy Coroot in minutes on a Kubernetes cluster of any size, providing a complete look into your Kubernetes cluster.
                </div>
                <div class="feature">
                    Service map with 100% coverage, including the internal Kubernetes control plane,
                    meaning you can discover problems whether they come from your application or from malfunctioning Kubernetes internal components.
                </div>
                <p>
                    To learn more about what Coroot can offer check out the <router-link :to="{name: 'features'}">Coroot Overview</router-link>.
                    Any questions or feedback? Reach out to us on <a href="https://join.slack.com/t/coroot-community/shared_invite/zt-1gsnfo0wj-I~Zvtx5CAAb8vr~r~vecyw" target="_blank"><v-icon>mdi-slack</v-icon>Slack</a>.
                </p>
            </v-col>
            <v-col cols="12" lg="6" order="1" order-lg="2">
                <v-carousel
                    :continuous="true"
                    :show-arrows="true"
                    :cycle="true"
                    :hide-delimiter-background="true"
                    :hide-delimiters="true"
                    :height="$vuetify.breakpoint.lg? '360px' : '100%'"
                >
                    <v-carousel-item>
                        <v-card class="ma-1 pa-3">
                            <ImageWrapper src="/static/img/service_map.png" />
                        </v-card>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-card class="ma-1 pa-3">
                            <ImageWrapper src="/static/img/app_map.png" />
                        </v-card>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-card class="ma-1 pa-3">
                            <ImageWrapper src="/static/img/app_health_summary.png" />
                        </v-card>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-card class="ma-1 pa-3">
                            <ImageWrapper src="/static/img/docs/coroot-ce/inspections/deployments.png" />
                        </v-card>
                    </v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>

        <Banner />

    </Page>
</template>

<script>
import Page from "@/pages/Page";
import Banner from "@/components/Banner.vue";

export default {
    components: {Page, Banner},
};
</script>

<style scoped>
.overview {
    font-family: Poppins, sans-serif;
}

.header {
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    margin-top: 40px;
}
.subheader {
    font-size: 24px;
    line-height: 40px;
    font-weight: 400;
    margin-top: 36px;
    margin-bottom: 12px;
    text-align: center;
}


.features {
    margin-top: 40px;
}
.feature {
    margin-bottom: 24px;
    padding-left: 16px;
}
.feature:before {
    content:'•';
    font-size: 32px;
    color: #3360FE;
    margin-left: -16px;
    margin-top: -12px;
    position: absolute;
}

@media (min-width: 600px) {
    .header {
        font-size: 40px;
        margin-top: 80px;
    }
    .features {
        margin-top: 60px;
    }
}
@media (min-width: 960px) {
    .header {
        font-size: 60px;
        margin-top: 100px;
    }
    .features {
        margin-top: 80px;
    }
}
</style>
